<section class="ev" *ngIf="visivel">
  <div class="ev-cartao">
    <div class="ev-cab">
      <div><span class="ev-rot">Evolução da loja</span><b>Fase {{ estado.evolucao.nomeFase }}</b></div>
      <span class="ev-pct">{{ estado.evolucao.pct }}%</span>
    </div>
    <div class="ev-fases">
      <div *ngFor="let f of fases" [class.feita]="f < estado.evolucao.fase" [class.atual]="f === estado.evolucao.fase">
        <i><em [style.width.%]="preenchimento(f)"></em></i><span>{{ nomeFase(f) }}</span>
      </div>
    </div>
    <div class="ev-proximas" *ngIf="estado.evolucao.proximas.length">
      <span>Para avançar:</span>
      <span class="ev-fato" *ngFor="let p of estado.evolucao.proximas">{{ p }}</span>
    </div>
    <div class="ev-acoes" *ngIf="(pendeEquipamento && !celular) || pendeDivulgar">
      <button type="button" class="onb-btn onb-btn--sec" *ngIf="pendeEquipamento && !celular" (click)="equipamentosAbertos = !equipamentosAbertos">
        <i class="fas fa-print"></i> {{ equipamentosAbertos ? 'Fechar equipamentos' : 'Extensão e impressora' }}
      </button>
      <button type="button" class="onb-btn onb-btn--sec" *ngIf="pendeDivulgar" (click)="copieLink()">
        <i class="far fa-copy"></i> {{ copiado ? 'Link copiado' : 'Copiar o link da loja' }}
      </button>
    </div>
    <p class="ev-no-computador" *ngIf="pendeEquipamento && celular">
      <i class="fas fa-desktop"></i> Extensão do WhatsApp e impressora você instala no computador: entre no painel por lá.
    </p>
    <app-onb-equipamentos *ngIf="equipamentosAbertos" [estado]="estado" (mudou)="atualize($event)"></app-onb-equipamentos>
  </div>

  <p class="ev-vem" *ngIf="vemAi">
    <i class="fe-compass"></i> Vem aí no seu menu: <b>{{ vemAi.nomes }}</b> · {{ vemAi.quando.toLowerCase() }}. Quer antes? Abra em Descobrir, no pé do menu.
  </p>
</section>
